<template>
  <div class="questionnaire" v-if="userInfo">
    <Header></Header>
    <div class="userinfo-card">
      <div class="my-card">
        <div class="my-card-header">
          <div class="left"></div>
          <div class="right">
            अपनी टिप्पणियाँ साझा करें! अपने विचार व्यक्त करें! पुरस्कार प्राप्त करें!
          </div>
          <div
            :class="['mobile-sign', { prohibit: isComplete }]"
            @click="accountsToday"
          >
            {{ isComplete ? "हस्ताक्षरित" : "लॉगिन" }}
          </div>
        </div>

        <div class="my-card-info">
          <img
            class="avatarUrl"
            :src="userInfo.avatarUrl"
            @click="skip('/uploadAvatar')"
          />
          <div class="infos">
            <div class="infos-top">
              <div class="infos-top-left">
                <div class="name">
                  <div>{{ userInfo.userName }}</div>
                  <div class="imgs">
                    <img
                      v-if="userInfo.paypal"
                      @click="skip('/settingsPaypal')"
                      src="@/assets/pcImg/questionnaire/paypal.png"
                      alt="图片"
                    />
                    <img
                      v-else
                      @click="skip('/settingsPaypal')"
                      src="@/assets/pcImg/questionnaire/paypal-grey.png"
                      alt="图片"
                    />
                  </div>
                </div>
                <div class="emali">{{ name }}</div>
              </div>
              <div class="mobile-infos-left">
                <div class="mobile-infos-lefts">
                  <div>
                    <img
                      class="avatarUrl"
                      @click="skip('/uploadAvatar')"
                      :src="userInfo.avatarUrl"
                    />
                  </div>
                  <div class="user-info">
                    <div class="user-name">{{ userInfo.userName }}</div>
                    <div class="emali">{{ userInfo.email }}</div>
                  </div>
                </div>
                <div class="mobile-img-boxs" @click="skip('/currentLevel')">
                  <img
                    class="medal"
                    src="@/assets/pcImg/questionnaire/medal.png"
                  />
                  <div class="medal-lv">
                    LV.{{ userInfo.credit | getCredit }}
                  </div>
                </div>
              </div>
              <div
                :class="['infos-top-right', { prohibit: isComplete }]"
                @click="accountsToday"
              >
                {{ isComplete ? "हस्ताक्षरित" : "Sign in" }}
              </div>
            </div>
            <div class="infos-line"></div>
            <div class="infos-bottom">
              <div class="img-boxs-available" @click="skip('/pointsHistory')">
                <div class="available">उपलब्ध</div>
                <div class="img-info">
                  <img
                    class="dollar"
                    src="@/assets/pcImg/questionnaire/$.png"
                  />
                  <div class="dollar-number">
                    {{ userInfo.balance | getDollar }}
                  </div>
                </div>
              </div>
              <div class="img-boxs" @click="skip('/rewards')">
                <img
                  class="cashout"
                  src="@/assets/pcImg/questionnaire/cashout.png"
                />
                <div class="cashout-text">निकासी</div>
              </div>
              <div
                class="img-boxs img-boxs-mobile"
                @click="skip('/currentLevel')"
              >
                <img
                  class="medal"
                  src="@/assets/pcImg/questionnaire/medal.png"
                />
                <div class="medal-lv">LV.{{ userInfo.credit | getCredit }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="question-mark"
        src="@/assets/pcImg/questionnaire/question-mark.png"
        alt="图片"
      />
    </div>

    <div class="questionnaire-list">
      <div class="earn-cash">
        <div>सर्वेक्षण पूरा करें और नकद कमाएँ</div>
        <div class="see-more">
          <span>अधिक देखें</span>
          <img src="@/assets/pcImg/questionnaire/arrowhead.png" alt="图片" />
        </div>
      </div>

      <div class="questionnaire-item-fa">
        <div
          class="questionnaire-item"
          v-for="(item, index) in IndividualSurveysArr"
          :key="index"
        >
          <div class="number-maxPoints">
            <div class="number">
              <div class="identifier">{{ item.number }}</div>
              <div>{{ item.title }}</div>
            </div>
            <div class="maxPoints">$ {{ item.maxPoints | getDollar }}</div>
          </div>

          <div class="facility-value">
            <div class="value">डिवाइस मूल्य</div>
            <div class="progress-ga">
              <div class="progress-fa">
                <van-progress
                  color="#2E67EA"
                  track-color="#E0E6F4"
                  :show-pivot="false"
                  :percentage="item.ir"
                />
              </div>
              <div class="percentage">{{ item.ir }}%</div>
            </div>
          </div>

          <div class="clock-join">
            <div>
              <img
                class="clock"
                src="@/assets/pcImg/questionnaire/clock.png"
                alt="图片"
              />
              <span>{{ item.loi }} मिनट</span>
            </div>
            <div class="join" @click="jumpToRecords(item)">भाग लें</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 文本框 -->
    <div class="text-box">
      <p>{{ questionnaireTexts[0] }}</p>
      <p>{{ questionnaireTexts[1] }}</p>
    </div>
    <div class="text-box-modle text-box-modle-color">
      <p>{{ questionnaireTexts[0] }}</p>
    </div>
    <div class="text-box-modle">
      <p>{{ questionnaireTexts[1] }}</p>
    </div>

    <!-- 文本框2 -->
    <div class="introduction-box" v-if="profileQuestionsList.length !== 0">
      <div class="introduction-left">
        <div class="title">आपकी सर्वेक्षण की संक्षिप्त जानकारी</div>
        <div class="profile">
          व्यक्तिगत जानकारी के सवालों के उत्तर दें ताकि आपको अधिक सर्वेक्षण मैच मिल सकें।
        </div>
        <div class="earn">हर 8 सवालों के जवाब देने पर $0.02 कमाएँ</div>
        <div class="introduction-progress">
          <div>
            <van-progress
              color="#2E67EA"
              track-color="#E0E6F4"
              :show-pivot="false"
              :percentage="percentage"
            />
          </div>
          <div>{{ percentage }}%</div>
        </div>
      </div>
      <div class="introduction-right">
        <div class="title">
          {{ profileQuestionsList[profileQuestionsIndex].title }}
        </div>

        <div class="answer" @click="develop">
          <span>{{ answer ? answer : "Please answer" }}</span>
          <img
            :class="['answer-arrowhead', { 'answer-rotate0': developStatus }]"
            src="@/assets/pcImg/questionnaire/arrowhead.png"
            alt="图片"
          />
        </div>
        <div class="answer-fa">
          <div class="answers">
            <div
              :class="['answer-item', { 'answer-item-border': index !== 0 }]"
              v-for="(item, index) in profileQuestionsList[
                profileQuestionsIndex
              ].options"
              :key="index"
              @click="answersClick(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="buttons">
          <div @click="previous" v-if="profileQuestionsIndex >= 1">
            पिछला
          </div>
          <div @click="accountsProfile">उत्तर</div>
        </div>
      </div>
    </div>
    <AnswereRegister
      :answerRegisterStatus="answerRegisterStatus"
      @registerClose="registerClose"
    ></AnswereRegister>
    <Footer></Footer>
  </div>
</template>
<script>
import { accounts } from "@/api/api.js";
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import AnswereRegister from "./mycom/answer-register.vue";
import {
  IndividualSurveys,
  users,
  getProfileQuestions,
  accountsProfile2,
  accountsToday,
  accountsTodayStatus,
} from "@/api/api.js";
import { Notify } from "vant";
import {
  questionnaire,
  buyCarDate,
  isHavingChildren,
  childrenBirthday,
} from "@/utlis/storageData.js";
import { getDateList } from "@/utlis/calendar.js";
import { Toast } from "vant";
export default {
  filters: {
    getDollar: (data) => {
      let number = (data / 100).toFixed(2);
      return number;
    },
    getCredit: (data) => {
      let grade = 1;
      if (data <= 60) {
        grade = 1;
      }
      if (data > 60 && data <= 100) {
        grade = 2;
      }
      if (data > 100 && data <= 200) {
        grade = 3;
      }
      if (data > 200 && data <= 500) {
        grade = 4;
      }
      if (data > 500 && data <= 800) {
        grade = 5;
      }
      if (data > 800 && data <= 1000) {
        grade = 6;
      }
      return grade;
    },
  },
  components: { Header, Footer, AnswereRegister },
  data() {
    return {
      loginInfo: null,
      userInfo: null,
      IndividualSurveysArr: [],
      questionnaireTexts: questionnaire,
      developStatus: true,
      name: "",
      profileQuestionsList: [],
      profileQuestionsList2: [],
      profileQuestionsIndex: 0,
      answer: null,
      answerID: null,
      isComplete: false,
      answerRegisterStatus: {
        dateList: [],
        registerDialogVisible: false,
      },
      brandIDOfCar: null,
      modelIDOfCar: null,
      parnetsOfChilden: null,
    };
  },
  watch: {
    profileQuestionsIndex: {
      handler(newvalue, oldvale) {
        this.developStatus = true;
        if (this.developStatus) {
          document.getElementsByClassName("answers")[0].style.height =
            32 *
              this.profileQuestionsList[this.profileQuestionsIndex].options
                .length +
            "px";
        }
      },
    },
  },
  methods: {
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    // 关闭弹窗
    registerClose() {
      this.answerRegisterStatus.registerDialogVisible = false;
    },
    //用户签到
    async accountsToday() {
      if (this.isComplete) {
        this.answerRegisterStatus.registerDialogVisible = true;
        return;
      }
      accountsToday({ id: this.loginInfo.id }).then((res) => {
        if (res.code === 200) {
          Notify({ type: "success", message: this.$t("signSta") });
          this.isComplete = true;
          this.accountsTodayStatus();
          this.answerRegisterStatus.registerDialogVisible = true;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //判断用户有没有签到
    async accountsTodayStatus() {
      await accountsTodayStatus({ id: this.loginInfo.id }).then((res) => {
        if (res.code === 200) {
          this.isComplete = res.data.isComplete;
          this.answerRegisterStatus.dateList = getDateList(res.data.days);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //获取用户信息
    async initPage() {
      //用户信息
      const params = {
        id: this.loginInfo.id,
      };
      await accounts(params).then((res) => {
        if (res.code === 200) {
          this.$store.commit("setAccountInfo", res.data);
          this.userInfo = res.data;
          console.log("获取用户信息", this.userInfo);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //获取问卷信息
    getIndividualSurveys() {
      const params = {
        id: this.loginInfo.id,
      };
      IndividualSurveys(params).then((res) => {
        if (res.code === 200) {
          this.IndividualSurveysArr = res.data;
          console.log(11, this.IndividualSurveysArr);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //展开回答
    develop() {
      this.developStatus = !this.developStatus;
      if (this.developStatus) {
        document.getElementsByClassName("answers")[0].style.height =
          32 *
            this.profileQuestionsList[this.profileQuestionsIndex].options
              .length +
          "px";
      } else {
        document.getElementsByClassName("answers")[0].style.height = 0;
      }
    },
    //
    getName() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      users(params).then((res) => {
        //console.log(res);
        if (res.code === 200) {
          console.log("res", res.data);
          this.name = res.data.name;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //跳转
    jumpToRecords(item) {
      let routeData = this.$router.resolve({
        path: "/questionnaireItem",
        query: { encryptId: item.encryptId },
      });
      window.open(routeData.href, "_blank");
    },
    //为车赋值品牌下种类赋值
    async getCarList() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      await users(params).then((res) => {
        if (res.code === 200) {
          if (res.data.brandIDOfCar && res.data.brandIDOfCar !== 1) {
            let option = [];
            this.brandIDOfCar = res.data.brandIDOfCar;
            this.modelIDOfCar = res.data.modelIDOfCar;
            this.parnetsOfChilden = res.data.parnetsOfChilden;
            this.profileQuestionsList[7].options2.forEach((item) => {
              if (item.brandID === res.data.brandIDOfCar) {
                option.push(item);
              }
            });
            this.profileQuestionsList[7].options = option;
          }
          //首次赋值索引
          let statu = true;
          let index = 0;
          while (statu && index <= 10) {
            if (this.profileQuestionsList[index].completed) {
              index++;
            } else {
              statu = false;
            }
          }
          if (index > 10) {
            index = 10;
          }
          if (index === 10) {
            if (!this.parnetsOfChilden) {
              this.profileQuestionsList.pop();
              index = 9;
            }
          }
          this.$nextTick(() => {
            this.profileQuestionsIndex = index;
          });
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //获取用户所需答题
    getProfileQuestions() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      getProfileQuestions(params).then((res) => {
        if (res.code === 200) {
          this.profileQuestionsList = res.data.questions;
          this.profileQuestionsList[8].options = buyCarDate();
          this.profileQuestionsList[9].options = isHavingChildren();
          this.profileQuestionsList[10].options = childrenBirthday();
          console.log(
            "this.profileQuestionsList",
            this.profileQuestionsList[10].options
          );
          this.profileQuestionsList[7].options2 = JSON.parse(
            JSON.stringify(this.profileQuestionsList[7].options)
          );
          this.profileQuestionsList2 = JSON.parse(
            JSON.stringify(this.profileQuestionsList)
          ); //保存数组
          this.getCarList();
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    //上一题
    previous() {
      //判断是否买车
      if (this.profileQuestionsIndex === 9) {
        const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
        const params = {
          id: loginInfo.id,
        };
        users(params).then((res) => {
          //console.log(res);
          if (res.code === 200) {
            console.log("res", res.data);
            if (res.data.brandIDOfCar === 1) {
              this.profileQuestionsIndex = this.profileQuestionsIndex - 3;
            } else {
              let option = [];
              this.profileQuestionsList[7].options2.forEach((item) => {
                if (item.brandID === res.data.brandIDOfCar) {
                  option.push(item);
                }
              });
              this.profileQuestionsIndex--;
              this.profileQuestionsList[7].options = option;
            }
          } else {
            Notify({ type: "danger", message: res.errors[0] });
          }
        });
      } else {
        this.profileQuestionsIndex--;
      }
      // 默认是展开
      this.answer = null;
      this.answerID = null;
    },
    //回答
    accountsProfile() {
      //问题没有回答提示
      if (!this.answer) {
        Toast("Please select your answer");
        return;
      }
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      if (this.profileQuestionsIndex === 0) {
        params.maritalStatusID = this.answerID || null;
      }
      if (this.profileQuestionsIndex === 1) {
        params.educationID = this.answerID || null;
      }
      if (this.profileQuestionsIndex === 2) {
        params.occupationStatusID = this.answerID || null;
      }
      if (this.profileQuestionsIndex === 3) {
        params.positionID = this.answerID || null;
      }
      if (this.profileQuestionsIndex === 4) {
        params.personalIncomeID = this.answerID || null;
      }
      if (this.profileQuestionsIndex === 5) {
        params.householdIncomeID = this.answerID || null;
      }
      if (this.profileQuestionsIndex === 6) {
        params.brandIDOfCar = this.answerID || null;
        this.brandIDOfCar = params.brandIDOfCar;
      }
      if (this.profileQuestionsIndex === 7) {
        params.modelIDOfCar = this.answerID || null;
        params.brandIDOfCar = this.brandIDOfCar;
        this.modelIDOfCar = params.modelIDOfCar;
      }
      if (this.profileQuestionsIndex === 8) {
        params.purchasedYearOfCar = this.answerID || null;
        params.brandIDOfCar = this.brandIDOfCar;
        params.modelIDOfCar = this.modelIDOfCar;
      }
      if (this.profileQuestionsIndex === 9) {
        if (this.answerID === 1) {
          params.parnetsOfChilden = true;
        } else if (this.answerID === 2) {
          params.parnetsOfChilden = false;
        } else {
          params.parnetsOfChilden = null;
        }
        //判断数组长度并赋值
        if (params.parnetsOfChilden) {
          this.profileQuestionsList = JSON.parse(
            JSON.stringify(this.profileQuestionsList2)
          );
        } else {
          if (this.profileQuestionsList[10]) {
            this.profileQuestionsList.pop();
          }
        }
        console.log(params.parnetsOfChilden);
        // return;
      }
      if (this.profileQuestionsIndex === 10) {
        params.birthYearOfYoungChild = this.answerID || null;
        params.parnetsOfChilden = true;
      }

      console.log(params, this.answerID, this.profileQuestionsIndex === 0);
      accountsProfile2(params).then((res) => {
        if (res.code === 200) {
          if (this.profileQuestionsIndex === 6 && this.answerID === 1) {
            this.profileQuestionsIndex = this.profileQuestionsIndex + 3;
          } else if (this.profileQuestionsIndex === 6) {
            let option = [];
            this.profileQuestionsList[7].options2.forEach((item) => {
              if (item.brandID === this.answerID) {
                option.push(item);
              }
            });
            this.profileQuestionsIndex++;
            this.profileQuestionsList[7].options = option;
          } else if (
            this.profileQuestionsIndex === 9 &&
            !params.parnetsOfChilden
          ) {
            console.log("不加了");
          } else {
            if (this.profileQuestionsIndex < 10) {
              this.profileQuestionsIndex++;
            }
          }
          this.answer = null;
          this.answerID = null;
        }
      });
    },
    answersClick(data) {
      this.answer = data.title;
      this.answerID = data.id;
    },
  },
  async mounted() {
    this.loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
    if (!this.loginInfo) return;
    await this.initPage();
    this.getName();
    this.getIndividualSurveys();
    this.getProfileQuestions();
    this.accountsTodayStatus();
  },
  computed: {
    percentage() {
      return parseInt(
        ((this.profileQuestionsIndex + 1) * 100) /
          this.profileQuestionsList.length
      );
    },
  },
};
</script>
<style scoped>
.questionnaire {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.userinfo-card {
  width: 100%;
  height: 180px;
  background-color: #2e67ea;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.my-card {
  width: 500px;
  height: 128.125px;
  background-color: #fff;
  border-radius: 6.25px;
  overflow: hidden;
}
.my-card-header {
  height: 36.875px;
  background-color: #5b90f2;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.my-card-header > .left {
  width: 10px;
  height: 10px;
  background: #efdc00;
  border-radius: 10px;
}
.my-card-header > .right {
  font-size: 11.25px;
  font-weight: bold;
  color: #ffffff;
}
.my-card-info {
  display: flex;
  margin-top: 10.625px;
}
.my-card-info > .avatarUrl {
  height: 37.5px;
  width: 37.5px;
  border-radius: 37.5px;
  background-color: #cccccc;
  margin-left: 6.25px;
  cursor: pointer;
}
.infos {
  width: calc(100% - 80px);
  margin-left: 13.75px;
}
.infos-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.infos-top-left > .name {
  display: flex;
  align-content: center;
  margin-top: 5px;
}
.infos-top-left > .name > .imgs {
  display: flex;
  align-content: center;
  margin-left: 35.625px;
}
.infos-top-left > .name > .imgs > img {
  width: auto;
  height: 10px;
  margin-right: 5px;
  cursor: pointer;
}
.infos-top-left > .name > div {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
}
.infos-top-left > .emali {
  font-size: 8.75px;
  font-weight: bold;
  color: #666666;
  margin-top: 8.125px;
}
.infos-top-right {
  width: 56.25px;
  height: 22.5px;
  line-height: 22.5px;
  background: #2e67ea;
  border-radius: 15px;
  font-size: 8.75px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
}
.infos-line {
  height: 0;
  border-top: 0.625px solid #eeeeee;
  margin-top: 6.25px;
}
.infos-bottom {
  display: flex;
  align-items: flex-end;
}
.img-boxs-available {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.available {
  font-size: 7.5px;
  color: #666666;
  margin-top: 6.25px;
}
.img-info {
  display: flex;
  justify-content: flex-start;
  margin-top: 6.25px;
}
.dollar {
  width: 11.25px;
}
.dollar-number {
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
  margin-left: 1px;
}
.img-boxs {
  display: flex;
  margin-left: 40px;
  align-items: center;
  cursor: pointer;
}
.cashout {
  width: 15px;
  position: relative;
  top: 2px;
}
.cashout-text {
  width: 31.25px;
  height: 11.25px;
  line-height: 11.25px;
  background: rgba(46, 103, 234, 0.1);
  border-radius: 1.875px;
  font-size: 7.5px;
  position: relative;
  top: 2px;
  color: #2e67ea;
  margin-left: 2px;
  text-align: center;
}

.question-mark {
  width: 133.75px;
  height: 133.75px;
}

/* 问卷列表 */
.questionnaire-list {
  width: calc(100% - 175px);
  margin: 37.5px auto;
}
.earn-cash {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
}

.see-more {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.see-more > span {
  font-size: 8.75px;
  font-weight: normal;
  color: #232323;
}
.see-more > img {
  width: 10px;
  margin-top: 2px;
  margin-left: 10px;
}

.questionnaire-item-fa {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.questionnaire-item {
  width: 153.125px;
  height: 143.75px;
  background: #f5f5f5;
  margin-top: 25px;
  border-radius: 4px;
  margin-right: calc((100% - 612.5px) / 3);
}
.questionnaire-item:nth-of-type(4n + 0) {
  margin-right: 0;
}
.number-maxPoints {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 18.75px;
}
.number-maxPoints > .number {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  color: #232323;
  margin-left: 12.5px;
  font-size: 8px;
}
.identifier {
  font-size: 9px;
  margin-bottom: 12.5px;
}
.maxPoints {
  width: 63.125px;
  height: 33.75px;
  background: #2e67ea;
  box-shadow: 0px 1.875px 5.625px 0.625px rgba(51, 106, 234, 0.55);
  border-radius: 5.625px;
  line-height: 33.75px;
  text-align: center;
  color: #fff;
  margin-right: 12.5px;
  font-weight: bold;
}
.facility-value {
  display: flex;
  flex-direction: column;
  margin-top: 21.875px;
  margin-left: 12.5px;
}
.facility-value > .value {
  font-size: 7.5px;
  color: #999999;
}
.progress-ga {
  display: flex;
  margin-top: 6.25px;
  align-items: center;
}
.progress-fa {
  width: 54.375px;
}
.percentage {
  font-size: 7.5px;
  color: #999999;
  margin-left: 5px;
}
.clock-join {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12.5px;
}
.clock-join img {
  width: 15px;
  margin-left: 12.5px;
}
.clock-join span {
  font-size: 10px;
  font-weight: 400;
  color: #666666;
}
.clock-join .join {
  width: 55px;
  height: 18.75px;
  line-height: 18.75px;
  border-radius: 9.375px;
  border: 0.625px solid #2e67ea;
  font-size: 8.75px;
  font-weight: bold;
  color: #2e67ea;
  text-align: center;
  margin-right: 12.5px;
  cursor: pointer;
  transition: background-color 0.5s;
}
.clock-join .join:hover {
  background-color: #2e67ea;
  color: #fff;
}
/* 文本框 */
.text-box {
  width: calc(100% - 207.5px);
  margin: 37.5px auto;
  background: #f5f5f5;
  border-radius: 2.5px;
  padding: 24px 16.25px;
  font-size: 8.75px;
  line-height: 15px;
}
.text-box > p:nth-child(1) {
  font-weight: 400;
  color: #b22525;
}
.text-box > p:nth-child(2) {
  font-weight: 400;
  margin-top: 24px;
  color: #232323;
}
/* 文本框2 */
.introduction-box {
  width: calc(100% - 207.5px);
  margin: 37.5px auto;
  background: #f5f5f5;
  border-radius: 2.5px;
  padding: 24px 16.25px;
  font-size: 8.75px;
  line-height: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.introduction-left {
  padding-right: 10px;
}
.introduction-left > .title {
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
  margin-bottom: 16px;
}
.introduction-left > .profile {
  font-size: 8.75px;
  font-weight: 400;
  color: #232323;
}
.introduction-left > .earn {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
  margin: 16px 0;
}
.introduction-left > .introduction-progress {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.introduction-progress > div:nth-child(1) {
  width: calc(100% - 30px);
}
.introduction-progress > div:nth-child(2) {
  color: #999999;
  margin-left: 10px;
}
.introduction-right {
  width: 428.75px;
  height: auto;
  background-color: #fff;
}
.introduction-right > .title {
  width: 100%;
  text-align: center;
  font-size: 11.25px;
  font-weight: bold;
  color: #232323;
  margin-top: 15px;
}
.answer-fa {
  max-height: 200px;
  overflow: scroll;
}
.answer {
  width: calc(100% - 30px);
  background-color: #f5f5f5;
  margin: 0 auto;
  font-size: 8.75px;
  text-align: center;
  position: relative;
  height: 18.75px;
  line-height: 18.75px;
  margin-top: 10px;
  cursor: pointer;
}
.answer-arrowhead {
  width: 10px;
  position: absolute;
  top: 4px;
  right: 5px;
  cursor: pointer;
  transform: rotate(0deg);
  transition: transform 0.3s;
}
.answer-rotate0 {
  transform: rotate(90deg);
}
.answers {
  width: calc(100% - 30px);
  margin: 0 auto;
  height: 80px;
  overflow: hidden;
  transition: height 0.3s;
}
.answer-item {
  border: 0.625px solid #eeeeee;
  height: 18.75px;
  line-height: 18.75px;
  text-align: center;
  cursor: pointer;
}
.answer-item-border {
  border-top: none;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  margin-right: 15px;
  margin-bottom: 20px;
}
.buttons > div {
  height: 18.75px;
  line-height: 18.75px;
  border-radius: 10px;
  padding: 0 10px;
  border: 0.625px solid #232323;
  color: #232323;
  font-size: 8.75px;
  margin-left: 10px;
  cursor: pointer;
}
.buttons > div:last-child {
  border: 0.625px solid #2e67ea;
  color: #2e67ea;
}

.prohibit {
  background-color: #909399 !important;
  cursor: no-drop !important;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1290px) {
  .question-mark {
    display: none;
  }
  .questionnaire-list {
    width: calc(100% - 60px);
  }
  .text-box,
  .introduction-box {
    width: calc(100% - 92.5px);
  }
}
@media only screen and (max-width: 1111px) {
  .questionnaire-item {
    width: 153.125px;
    height: 143.75px;
    background: #f5f5f5;
    margin-top: 25px;
    border-radius: 4px;
    margin-right: calc((100% - 459.375px) / 2);
  }
  .questionnaire-item:nth-of-type(3n) {
    margin-right: 0;
  }
  .questionnaire-item:nth-of-type(4n) {
    margin-right: calc((100% - 459.375px) / 2);
  }
}
@media only screen and (max-width: 840px) {
  .my-card {
    width: 450px;
  }
  .questionnaire-list {
    width: calc(100% - 8px);
  }
  .text-box,
  .introduction-box {
    width: calc(100% - 40.5px);
  }
}
</style>
<style scoped>
/* 进入移动端 */
.mobile-sign {
  display: none;
  width: 44.375px;
  height: 16.25px;
  line-height: 16.25px;
  background: #0551ff;
  border-radius: 16.25px;
  font-size: 7.5px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  font-weight: normal;
}
.mobile-infos-left {
  display: none;
  justify-content: space-between;
  align-items: center;
}
.mobile-infos-lefts {
  display: flex;
}
.mobile-infos-left .avatarUrl {
  height: 37.5px;
  width: 37.5px;
  border-radius: 37.5px;
  background-color: #cccccc;
  margin-left: 6.25px;
  cursor: pointer;
}
.mobile-infos-left .user-info {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  margin-left: 10px;
  justify-content: space-between;
}
.mobile-infos-lefts .user-name {
  font-size: 10px;
  font-weight: bold;
  margin-top: 6px;
}
.mobile-infos-lefts .emali {
  font-size: 7.5px;
  margin-bottom: 6px;
}
.mobile-img-boxs {
  display: flex;
  margin-right: 10px;
  cursor: pointer;
}
.mobile-img-boxs > img {
  width: 15px;
  height: 15px;
  position: relative;
  left: 15px;
}
.mobile-img-boxs > div {
  width: 31.25px;
  height: 14px;
  font-size: 7.5px;
  line-height: 14px;
}
.medal {
  width: 18.75px;
  position: relative;
  right: -16px;
}
.medal-lv {
  width: 36.875px;
  height: 14px;
  line-height: 14px;
  background: rgba(46, 103, 234, 0.1);
  border-radius: 10px;
  font-size: 8.75px;
  font-weight: bold;
  color: #2e67ea;
  text-align: right;
  padding-right: 5px;
  position: relative;
  top: 1px;
}
.text-box-modle {
  width: 85vw;
  display: none;
  font-size: 10px;
  padding: 12.5px;
  margin: 0 auto;
  background-color: #f5f5f5;
  line-height: 15px;
  margin-bottom: 10px;
  color: #232323;
}
.text-box-modle-color {
  color: #a4332d;
}
@media only screen and (max-width: 751px) {
  .my-card {
    width: calc(100% - 20px);
  }
  .mobile-sign {
    display: block;
  }
  .my-card-header {
    justify-content: space-around;
  }
  .my-card-header > .right {
    width: 200px;
    font-size: 8.75px;
    line-height: 13px;
  }
  .infos-top-right {
    display: none;
  }
  .my-card-info > .avatarUrl {
    display: none;
  }
  .infos-top-left {
    display: none;
  }
  .mobile-infos-left {
    display: flex;
    width: 100%;
  }
  .infos {
    width: 100%;
  }
  .img-boxs-mobile {
    display: none;
  }
  .infos-bottom {
    justify-content: space-between;
    align-items: center;
  }
  .infos-bottom .img-boxs {
    margin-right: 20px;
  }
  .infos-bottom .img-boxs-available {
    margin-left: 10px;
  }
  .dollar-number {
    font-size: 10px;
  }
  .questionnaire-item {
    width: 153.125px;
    height: 143.75px;
    background: #f5f5f5;
    margin-top: 25px;
    border-radius: 4px;
    margin-right: calc((100% - 306.25px) / 4) !important;
    margin-left: calc((100% - 306.25px) / 4);
  }

  .earn-cash {
    width: 90vw;
    margin: 0 auto;
  }
  .text-box {
    display: none;
  }
  .text-box-modle {
    display: block;
  }
  .introduction-box {
    flex-direction: column;
    background-color: #fff;
    align-items: flex-start;
  }
  .introduction-right {
    margin-top: 10px;
    width: 100%;
  }
  .introduction-right > .title {
    text-align: left;
  }
  .introduction-right > .answer {
    width: 100%;
    margin: 0;
    padding: 0;
    margin-top: 20px;
  }
  .introduction-right .answers {
    width: 100%;
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire.vue